/**
 * External Imports
 */
import { FC, useState } from 'react';

/**
 * Internal Imports
 */
import SideNav from '../../components/sideNav/adminSideNav/AdminSideNav';
import UnitsTable from '../../components/customTables/admin/areasTable/UnitsTable';
import DepartmentsTable from '../../components/customTables/admin/areasTable/DepartmentsTable';

import { useUserRolesRef } from '../../services/UserRoles';

/**
 * Style Imports
 */
import {
  AreasContainer,
  AreasContainerInner
} from './styles/AdminViews.styles';

const Areas: FC = () => {
  const [selectedTab, setSelectedTab] = useState<string>('units');

  const { isEnterpriseAdmin } = useUserRolesRef();

  const menuItems = [
    { tabLabel: 'Units', tabId: 'units' },
    ...(isEnterpriseAdmin
      ? [{ tabLabel: 'CSC Departments', tabId: 'departments' }]
      : [])
  ];

  return (
    <AreasContainer data-testid="admin-area-list-view">
      <SideNav
        navItems={menuItems}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      <AreasContainerInner>
        {selectedTab && selectedTab === 'units' && <UnitsTable />}
        {selectedTab && selectedTab === 'departments' && <DepartmentsTable />}
      </AreasContainerInner>
    </AreasContainer>
  );
};

export default Areas;
